import { IconClock } from "@tabler/icons-react";
import styles from "./Support.module.css";

export default function ResponseTimesCard() {
  return (
    <div className={styles.sideCard}>
      <div className={styles.sideCardHeader}>
        <div className={styles.sideCardIcon}>
          <IconClock size={16} />
        </div>
        <span className={styles.sideCardTitle}>Response Times</span>
      </div>
      <div className={styles.sideCardBody}>
        <div className={styles.responseGrid}>
          <div className={styles.responseItem}>
            <div className={styles.responseLabel}>Email</div>
            <div className={styles.responseValue}>4–8</div>
            <div className={styles.responseUnit}>hours avg.</div>
          </div>
          <div className={styles.responseItem}>
            <div className={styles.responseLabel}>Live Chat</div>
            <div className={styles.responseValue}>&lt; 5</div>
            <div className={styles.responseUnit}>mins avg.</div>
          </div>
        </div>
        <p className={styles.sideNote}>
          Business hours: Mon–Fri, 9 am–6 pm WAT. Critical issues are handled
          24/7.
        </p>
      </div>
    </div>
  );
}
